import { twMerge } from 'tailwind-merge';

import type { Team } from '@/types/api';

export const TeamInfo = ({
  score,
  team,
  reverse = false,
}: {
  score: number;
  team: Team;
  reverse?: boolean;
}) => {
  return (
    <div
      className={twMerge(
        'flex items-center leading-none',
        reverse ? 'flex-row-reverse' : 'flex-row',
      )}
    >
      <div>
        {team.team_image_url ? (
          <img
            className="size-[18vh]"
            src={team.team_image_url}
            alt={team.name}
          />
        ) : (
          <span
            className={twMerge(
              'fi text-[12vh]',
              team.country_code && `fi-${team.country_code}`,
            )}
          />
        )}
      </div>
      <div className="flex-1 px-[2vh]"></div>
      <div className="text-[15vh] font-bold uppercase text-slate-700">
        {team.scoreboard_name}
      </div>
      <div className="flex-1 px-[3vh]"></div>
      <div className="text-[20vh] font-medium uppercase">{score}</div>
    </div>
  );
};
